export default {
  routerObj: {
    path: '/terraceManage',
    component: () => import('@/views/routerView.vue'),
    name: '平台管理',
    children: [
      {
        path: '/terraceManage/terraceManageHome',
        component: () => import('@/views/terraceManage/terraceManageHome/index.vue'),
        name: '平台管理主页'
      },
      {
        path: '/terraceManage/aipage',
        component: () => import('@/views/terraceManage/aipage/index.vue'),
        name: 'AI配置'
      },
      {
        path: '/terraceManage/aiAssistantPage',
        component: () => import('@/views/terraceManage/aiAssistantPage/index.vue'),
        name: 'AI小助手配置'
      },
      {
        path: '/terraceManage/messagePage',
        component: () => import('@/views/terraceManage/messagePage/index.vue'),
        name: '短信配置'
      },
      {
        path: '/terraceManage/userManage',
        component: () => import('@/views/terraceManage/userManage/index.vue'),
        name: '系统用户'
      },
      {
        path: '/terraceManage/menuManage',
        component: () => import('@/views/terraceManage/menuManage/index.vue'),
        name: '菜单管理'
      },
      {
        path: '/terraceManage/roleManage',
        component: () => import('@/views/terraceManage/roleManage/index.vue'),
        name: '角色管理'
      },
      {
        path: '/terraceManage/addressBookGroup',
        component: () => import('@/views/terraceManage/addressBookGroup/index.vue'),
        name: '通讯录组织'
      },
      {
        path: '/terraceManage/userGuide',
        component: () => import('@/views/terraceManage/userGuide/index.vue'),
        name: '使用手册'
      },
      {
        path: '/terraceManage/addressManage',
        component: () => import('@/views/terraceManage/addressManage/index.vue'),
        name: '区域管理'
      },
      {
        path: '/terraceManage/authorizationManage',
        component: () => import('@/views/terraceManage/authorizationManage/index.vue'),
        name: '授权时效管理'
      }
    ]
  }
}
